import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=ba69d33c&scoped=true&lang=pug&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"
import style0 from "./icon.vue?vue&type=style&index=0&id=ba69d33c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba69d33c",
  null
  
)

export default component.exports